// HOOKS
import { useState, createContext, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
// GRAPHQL
import { GET_PRODUCTS } from "../graphql/queries/products/products.queries";

const getCategories = (products) => {
  const appleCategories = ["iPad", "MacBook"];
  const categoriesSet = new Set(products.map((product) => product.category));
  const categories = Array.from(categoriesSet).map((category) => ({
    name: category,
    link: `${
      appleCategories?.includes(category)
        ? `/${category.toLowerCase()}/apple`
        : `/${category.toLowerCase()}`
    }`,
  }));

  return categories;
};

export const ProductsContext = createContext({
  products: [],
  setProducts: () => {},
  categories: [],
  setCategories: () => {},
  makes: [],
  setMakes: () => {},
  getModels: () => {},
  getProducts: () => {},
  getMakes: () => {},
  fetchProducts: () => {},
});

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [makes, setMakes] = useState([]);
  const [productsQuery] = useLazyQuery(GET_PRODUCTS, {
    variables: { query: { limit: 0 }, product: {} },
  });

  const fetchProducts = async () => {
    const res = await productsQuery();
    if (res) {
      setProducts(res.data.products.products);
      setCategories(getCategories(res.data.products.products));
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const getModels = (category, make) => {
    const filteredProducts = products.filter(
      (product) =>
        product.category.toLowerCase() === category &&
        product.make.toLowerCase() === make
    );
    const modelsSet = new Set(filteredProducts.map((product) => product.model));
    const models = Array.from(modelsSet).map((model) => ({
      name: model,
      link: `/${category}/${make}/${model}`.toLowerCase(),
    }));
    return models;
  };

  const getProducts = (category, make, model) => {
    const filteredProducts = products.filter(
      (product) =>
        product.category.toLowerCase() === category &&
        product.make.toLowerCase() === make &&
        product.model.toLowerCase() === model
    );
    return filteredProducts;
  };

  const getMakes = (category) => {
    const filteredProducts = products.filter((product) => {
      return product.category.toLowerCase() === category;
    });
    const makesSet = new Set(filteredProducts.map((product) => product.make));
    const makes = Array.from(makesSet).map((make) => ({
      name: make,
      link: `/${category}/${make}`.toLowerCase(),
    }));
    return makes;
  };

  return (
    <ProductsContext.Provider
      value={{
        products,
        setProducts,
        categories,
        makes,
        getModels,
        getProducts,
        getMakes,
        fetchProducts,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
